import { ServiceDataFields } from './service-data-fields.enum';

export const monoFieldSet = [
  ServiceDataFields.MonogenicIncidentalFindings,
  ServiceDataFields.PregnancyInformation,
  ServiceDataFields.DueDate,
  ServiceDataFields.PregnancyType,
  ServiceDataFields.Ivf,
  ServiceDataFields.VanishingTwinSyndrome,
  ServiceDataFields.HeparinTherapy,
  ServiceDataFields.DateOfUltrasound,
  ServiceDataFields.PatientHistoryInformation,
  ServiceDataFields.MonogenicDisorderCarrier,
  ServiceDataFields.PreviousPregnanciesGeneticCondition,
  ServiceDataFields.FamilyHistoryOfGeneticDiseases,
  ServiceDataFields.CarrierOfGeneticCondition,
  ServiceDataFields.HistoryOfCancer,
  ServiceDataFields.HumanSerumAlbuminTherapy,
  ServiceDataFields.CellularImmunotherapy,
  ServiceDataFields.StemCellTherapy,
  ServiceDataFields.TransplantSurgery,
  ServiceDataFields.BloodTransfusion,
  ServiceDataFields.AdditionalPatientInformation,
  ServiceDataFields.Weight,
  ServiceDataFields.Height,
  ServiceDataFields.DocumentNumber,
];
